import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
const Navigation = styled.nav `
  display: block;
  margin-left: auto;

  @media ${until(Device.Tablet)} {
    display: none;
  }
`;
const NavigationList = styled.ul `
  display: flex;
  align-items: center;
`;
const NavigationItem = styled.li `
  display: block;

  & + & {
    margin-left: 16px;
  }

  @media ${from(Device.TabletLarge)} {
    & + & {
      margin-left: 54px;
    }
  }
`;
const NavigationLink = styled.a `
  display: block;
  color: currentColor;
  ${fonts.crimsonText.regular};
  font-size: 18px;
  line-height: 24px;
  text-decoration: none;
  text-underline-position: under;

  &[data-active='true'] {
    text-decoration: underline;
  }

  &:focus,
  &:hover {
    color: ${brand.gold};
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 23px;
    line-height: 31px;
  }
`;
export default {
    Navigation,
    NavigationItem,
    NavigationLink,
    NavigationList,
};
